import mitt from 'mitt'
import { App } from 'vue'

export default {
  install: (app: App < Element >) => {
    const vue = app
    vue.config.globalProperties.$mitt = mitt()
  }
}
